import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import useRole from "../../auth/useRole";
import useActiveBusinessMembership from "../../hooks/useActiveBusinessMembership";
import useStore from "../../store/useStore";
import { resolveBusinessGate } from "../../services/postAuthRouting";
import BusinessRequiredState from "../business/BusinessRequiredState";

export default function RequireBusinessAnalyticsAccess() {
  const { user, loading } = useAuth() || {};
  const { isAdmin } = useRole();
  const { userProfile } = useStore();
  const {
    membershipLoading,
    hasActiveBusinessContext,
    isActiveBusinessProfileLive,
  } = useActiveBusinessMembership();
  const loc = useLocation();

  if (loading) return null;
  if (!user) return <Navigate to="/signin" state={{ from: loc }} replace />;
  // An admin without an active business context works from the executive dashboard instead.
  if (isAdmin && !hasActiveBusinessContext) {
    return <Navigate to="/admin/analytics" state={{ from: loc }} replace />;
  }
  if (isAdmin) return <Outlet />;

  // Avoid flashing the gate while the business's live status is still resolving.
  if (membershipLoading && hasActiveBusinessContext) return null;

  const gate = resolveBusinessGate({
    accountType: userProfile?.accountType,
    hasActiveBusinessContext,
    isActiveBusinessProfileLive,
  });
  if (!gate.allowed) {
    return (
      <BusinessRequiredState
        reason={gate.reason}
        featureLabel="Campaign Analytics"
        nextPath={`${loc.pathname}${loc.search || ""}`}
      />
    );
  }

  return <Outlet />;
}
